import type { Pead } from "epsm-api-types/models";
import config from "../../../config";
import { getMinMaxPrice } from "../getMinMaxPrice/getMinMaxPrice";

const { CHART_PADDING } = config;

export function getYAxisRange(
	relativeToSpy: boolean,
	pead: Pead | null,
	series: echarts.SeriesOption[],
	stdDev = false,
	isMainChart = false,
) {
	if (!pead) return { min: 0, max: 0 };
	const prices = series.find((s) => s.name === "Price")?.data as number[][];
	const priceRange = getMinMaxPrice(prices);

	const getLines = () => {
		const baseLines = [
			...(pead.avg || []),
			...(pead.min || []),
			...(pead.max || []),
		];

		const stdDevLines =
			stdDev && isMainChart
				? [
						...(pead.sigma1 || []),
						...(pead.sigma2 || []),
						...(pead.sigma_minus1 || []),
						...(pead.sigma_minus2 || []),
					]
				: [];

		const spyLines = relativeToSpy
			? [
					...(pead.max_spy || []),
					...(pead.min_spy || []),
					...(pead.avg_spy || []),
				]
			: [];

		const spyStdDevLines =
			relativeToSpy && isMainChart && stdDev
				? [
						...(pead.sigma1_spy || []),
						...(pead.sigma2_spy || []),
						...(pead.sigma_minus1_spy || []),
						...(pead.sigma_minus2_spy || []),
					]
				: [];

		const priceRangeLine = isMainChart ? [...(priceRange || [])] : [];

		return [
			...baseLines,
			...stdDevLines,
			...priceRangeLine,
			...spyLines,
			...spyStdDevLines,
		];
	};

	const allLines = getLines();

	const allPrices = allLines.map((line) => line.price).sort((a, b) => a - b);

	return {
		min: !allPrices.length ? 0 : allPrices[0] - allPrices[0] * CHART_PADDING,

		max: !allPrices.length
			? 0
			: allPrices[allPrices.length - 1] +
				allPrices[allPrices.length - 1] * CHART_PADDING,
	};
}
